// Shared money formatting helper — client-side counterpart to the
// `money_without_trailing_zeros` Liquid filter. Interpolates the shop's own
// native money_format string (exposed via data-money-format on <html> in
// layout/theme.liquid) so JS-driven price updates (variant change, carousel
// cards) match server-rendered prices exactly. The theme never appends its
// own currency text — the shop's money_format already contains it.
window.Velo = window.Velo || {};
window.Velo.formatMoney = function (cents) {
  var format = document.documentElement.getAttribute('data-money-format') || '{{amount}}';
  var value = Math.round(cents) / 100;
  var hasDecimals = Math.round(cents) % 100 !== 0;
  var amount = hasDecimals ? value.toFixed(2) : String(Math.round(value));
  var amountNoDecimals = String(Math.round(value));
  return format
    .replace('{{amount}}', amount)
    .replace('{{amount_no_decimals}}', amountNoDecimals);
};
